// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__HoRNx","insightsList":"newBusinessInsightsMenu_insightsList__KyDZu","active":"newBusinessInsightsMenu_active__2ehbZ"};